import { Alert, Button, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import ExternalTrainingFilter from "./ExternalTrainingFilter";
import ExternalTrainingModal from './ExternalTrainingModal';
import { external_training_list } from '../../../redux/actions/training.action';
import { useDispatch, useSelector } from "react-redux";
import dummyDataList from './TraininglistDummyData.json';
import { StencilList } from "react-placemoulder";
import ExternalTrainingList from "./ExternalTrainingList";
import InfiniteScroll from "react-infinite-scroller";
import { useNavigate } from "react-router";
import { ConfirmationModal, CustomizedSnackbar } from "../../../shared";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";
import { axiosFetch } from "../../../utils/AxiosFetch";
import ExternalAttendeesModal from "./ExternalAttendeesModal";


function ExternalTraining() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(false);
    const [listLoading, setListLoading] = useState(true);
    const [list, setList] = useState(dummyDataList);
    const [pageNo, setPageNo] = useState(1);
    const [resultsPerPage, setResultsPerPage] = useState(3);
    const [pagination, setPagination] = useState({});
    const [scrolling, setScrolling] = useState(false);
    const [title, setTitle] = useState("");
    const [date, setDate] = useState("");
    const [year, setYear] = useState("");
    const [emp, setEmp] = useState(0);
    const [isActive, setIsActive] = useState(true);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [id, setId] = useState(0);
    const [trainingName, setTrainingName] = useState("");
    const [isEdit, setIsEdit] = useState(false);
    const [trainingDetail, setTrainingDetail] = useState("");
    const [attendees, setAttendees] = useState([]);
    const [userIds, setUserIds] = useState("");
    const [attendeesOpen, setAttendeesOpen] = useState(false);



    const externalTrainings = useSelector(state => state.fetchExternalTrainingList_Reducer.externalTrainingList)

    useEffect(() => {
        var req = {
            "title": title,
            "dateFilter": date,
            "year": year,
            "isActive": isActive,
            "employeeId": emp,
            "page": pageNo,
            "resultsPerPage": resultsPerPage
        }
        dispatch(external_training_list(req));
        setId(0);
    }, [])

    useEffect(() => {
        if (externalTrainings !== undefined) {
            if (externalTrainings.pagination !== undefined) {
                setPagination(externalTrainings.pagination)
                setPageNo(externalTrainings.pagination.page)
            }
            if (list && list.length > 0 && externalTrainings.pagination && externalTrainings.pagination.page > 1) {

                var trainingList = [...list, ...externalTrainings.trainings];
                setList(trainingList)
                setScrolling(false);
                if (externalTrainings.pagination !== undefined) {
                    setPagination(externalTrainings.pagination)
                    setPageNo(externalTrainings.pagination.page)
                }
            }
            else {
                setListLoading(false)
                setList(externalTrainings.trainings)
                if (externalTrainings.pagination !== undefined) {
                    setPagination(externalTrainings.pagination)
                    setPageNo(externalTrainings.pagination.page)
                }
            }

        }
    }, [externalTrainings])
    const handleClick = () => {
        if (isOpen) {
            setIsEdit(false);
            setTrainingDetail("");
            setIsOpen(false)
        }
        else {
            setIsOpen(true);
            setTrainingDetail("");
        }
    }
    const handlePagination = () => {
        if (pageNo + 1 <= pagination.totalPages) {
            setPageNo(pageNo + 1)
            var req = {
                "title": title,
                "dateFilter": date,
                "year": year,
                "isActive": isActive,
                "employeeId": emp,
                "page": pageNo + 1,
                "resultsPerPage": resultsPerPage
            }
            dispatch(external_training_list(req))
            setScrolling(true)
        }
    }
    const handleBack = () => {
        navigate("/trainings/team")
    }
    const handleTitleChange = (val) => {
        setTitle(val)
    }
    const handleDateFilterChange = (val) => {
        setDate(val)
    }
    const handleYearFilterChange = (val) => {
        setYear(val)
    }
    const handleEmployeeChange = (val) => {
        setEmp(val)
    }
    const handleInactiveTraining = (val) => {
        setIsActive(val)
    }
    const handleFilter = (val) => {
        if (val === 1) {
            setListLoading(true)
            dispatch(external_training_list())
        }
        else {
            setListLoading(true)

            var req = {
                "title": title,
                "dateFilter": date,
                "year": year,
                "isActive": isActive,
                "employeeId": emp,
                "page": 1,
                "resultsPerPage": resultsPerPage
            }
            dispatch(external_training_list(req))

        }

    }
    const handleDelete = () => {
        axiosFetch({
            url: `/training/external/delete/${id}`,
            method: "delete",
        })
            .then((res) => {
                if (res.status === 200) {
                    dispatch(SnackbarActions(true, "success", `Deleted Successfully `))
                    handleDeleteConfirmation()
                    dispatch(external_training_list())
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                    handleDeleteConfirmation()

                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleDeleteConfirmation = (id, name) => {
        if (openConfirmation) {
            setId(0);
            setOpenConfirmation(false)
        }
        else {
            setId(id);
            setTrainingName(name);
            setOpenConfirmation(true)
        }
    }
    const handleEditTraining = (id) => {
        setId(id);
        setIsEdit(true);
        handleClick();
        getAttendees(id);
        getDetails(id);
    }

    const getDetails = (id) => {
        axiosFetch({
            url: `/training/external/${id}`,
            method: "get",
        })
            .then((res) => {
                if (res.status === 200) {
                    setTrainingDetail(res.data)
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));

                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const getAttendees = (id) => {
        axiosFetch({
            url: `/training/external/attendees/${id}`,
            method: "get",
        })
            .then((res) => {
                if (res.status === 200) {
                    setAttendees(res.data)
                    var ids = [];
                    if (res.data.length > 0) {
                        res.data.map((option) => {
                            ids.push(option.id);
                        });
                        setUserIds(ids)
                    }
                }
                if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));

                }
                if (res.status === 401) {
                    navigate("/");
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    const handleAttendeesModal = (id) => {
        if (attendeesOpen) {
            setId(0)
            setAttendeesOpen(false)
        }
        else {
            setId(id);
            setAttendeesOpen(true);
            getAttendees(id);
            getDetails(id)
        }
    }
    return (
        <div>
                   
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h1 className="main-heading">Team Member's External Trainings</h1>
                    <Button sx={{ marginLeft: 1 }} className="theme-btn m-top" variant="contained" onClick={() => handleBack()}>Back</Button>
                    <Button sx={{ float: "right" }} className="theme-btn m-top" variant="contained" onClick={() => handleClick()}>Add External trainings</Button>   
                    {pagination && pagination.totalRecords > 0?
                <p style={{ marginLeft: "10px", marginTop: "0px", marginBottom: "0" }}>You have got {pagination.totalRecords} trainings </p> : ""}  
                </Grid>
                <Grid item xs={3}>
                    <ExternalTrainingFilter active={isActive}
                        handleTitleChange={handleTitleChange}
                        handleDateFilter={handleDateFilterChange}
                        handleyearFilter={handleYearFilterChange}
                        handleEmployee={handleEmployeeChange}
                        handleInactive={handleInactiveTraining}
                        handleFilter={handleFilter}
                />
                </Grid>
                <Grid item xs={9}>
                    {listLoading ?
                        <StencilList
                            length={3}
                            Component={ExternalTrainingList}
                            data={list}
                        /> :
                        <InfiniteScroll
                            // dataLength={trainingList.length}
                            initialLoad={false}
                            loadMore={scrolling === false ? handlePagination : ""}
                            hasMore={pageNo <= pagination.totalPages}
                            threshold={500}
                        >
                            {list && list.length > 0 ?
                                list.map((training) => {
                                    return <ExternalTrainingList {...training} handleDelete={handleDeleteConfirmation} handleEdit={handleEditTraining} handleAttendees={handleAttendeesModal}/>
                                }) :
                                <Alert severity="error">No trainings found for your team members</Alert>
                            }

                        </InfiniteScroll>
                    }
                </Grid>
            </Grid>

            <ExternalTrainingModal open={isOpen} handleModal={handleClick} edit={isEdit} id={id} data={trainingDetail} attendees={userIds}/>
            <ConfirmationModal open={openConfirmation} handleClose={handleDeleteConfirmation} message={`Are you sure you want to delete "${trainingName}" training?`} handleYes={handleDelete} />
            <ExternalAttendeesModal open={attendeesOpen} handleAttendees={handleAttendeesModal} users={attendees} data={trainingDetail}/>

            <CustomizedSnackbar />

        </div>
    )
}
export default ExternalTraining;